import dynamic from "next/dynamic";

export const FormSideImage = dynamic(() => import("./component"));
